define('module/hotspot',[
    'jquery',
    'underscore',
    'cnf',
    '_pubsub'
], function($, _, Cnf, Pubsub) {
    'use strict';

    /**
     * handle hotspot
     * 
     * @jira FDZ-682
     * @date 2023-08-04
     * @author sh@sopg.de
     */

    return function()
    {
        var oPubsub=new Pubsub();

        this.cnf = {
            selector: {
                el: '.ce-hotspot',
                hotspot_wrapper: '.js-hotspot-wrapper',
                hotspot_inner: '.js-hotspot-inner',
                hotspots: '.js-hotspot',
                popup: '.js-hotspot-popup',
                popup_content: '.js-hotspot-popup-content',
                popup_close : '.js-close'
            },
            data: {
                minheight: 'minheight',
                jsonvar: 'jsonvar'
            }
        };

        /**
         * main entry
         */
        this.init = function()
        {
            this.$el = Cnf.$app.find(this.cnf.selector.el);
            if(this.$el.length <= 0) {
                return;
            }

            this.oHotspot = {};

            this.initElement();
            this.initEvent();
        };

        /**
         * init element
         * 
         * @jira FDZ-682
         * @date 2023-08-04
         * @author sh@sopg.de
         */
        this.initElement = function()
        {
            _.each(this.$el, function(item, index) {
                this.oHotspot[index] = {
                    $el: this.$el.eq(index),
                    $wrapper: this.$el.eq(index).find(this.cnf.selector.hotspot_wrapper),
                    $inner: this.$el.eq(index).find(this.cnf.selector.hotspot_inner),
                    $hotspot: this.$el.eq(index).find(this.cnf.selector.hotspots),
                    iHotspotWidth: this.$el.eq(index).find(this.cnf.selector.hotspots).eq(0).width(),
                    $popup: this.$el.eq(index).find(this.cnf.selector.popup),
                    $popup_content : this.$el.eq(index).find(this.cnf.selector.popup_content),
                    $close: this.$el.eq(index).find(this.cnf.selector.popup_close),
                    minheight: this.$el.eq(index).data(this.cnf.data.minheight),
                    jsonvar: this.$el.eq(index).data(this.cnf.data.jsonvar),
                    isDraggable: false
                };

                //init draggable
                Draggable.create(this.oHotspot[index].$inner, {
                    type: "x",
                    bounds: this.oHotspot[index].$wrapper,
                    lockAxis: true,
                    dragResistance: 0,
                    allowEventDefault: true
                });

                this.oHotspot[index].drag = Draggable.get(this.oHotspot[index].$inner);
            }, this);
        };

        /**
         * init event
         * 
         * @jira FDZ-682
         * @date 2023-08-04
         * @author sh@sopg.de
         */
        this.initEvent = function()
        {
            _.each(this.oHotspot, function(item, index) {

                //add listener on each hotspot
                _.each(this.oHotspot[index].$hotspot, function(hotspot, index_hotspot) {
                    this.oHotspot[index].$hotspot.eq(index_hotspot).click(_.bind(this.clickHotspot, this, index, index_hotspot));
                }, this);

                //add listener on close
                this.oHotspot[index].$close.click(_.bind(this.hidePopup, this, index));

                //add pubsub
                oPubsub.on(Pubsub.RESIZE, _.bind(this.onResize,this));
                this.onResize();

            }, this);
        };

        /**
         * callback click hotspot
         * 
         * @jira FDZ-682
         * @date 2023-08-04
         * @author sh@sopg.de
         * 
         * @param {int} index
         * @param {int} index_hotspot
         * @param {object} ev
         */
        this.clickHotspot = function(index, index_hotspot, ev)
        {
            ev.preventDefault();

            if(this.oHotspot[index].$popup_content.html().length > 0) {
                oPubsub.trigger(Pubsub.DELETE_VIDEO, this.oHotspot[index].$popup_content);
                this.oHotspot[index].$popup_content.html('');//reset position of scrollbar
            }

            this.oHotspot[index].$popup_content.html(window[this.oHotspot[index].jsonvar][index_hotspot].text);

            //trigger video routine
            oPubsub.trigger(Pubsub.INIT_VIDEO, this.oHotspot[index].$popup_content);
            if(
                (typeof window.BorlabsCookie === "object")
                && (true === window.BorlabsCookie.checkCookieConsent("youtube"))
            ) {
                window.BorlabsCookie.unblockContentId("youtube");
            }

            //center if is draggable
            if(true === this.oHotspot[index].isDraggable) {
                
                //x position from center of viewport
                const iCenter = (this.oHotspot[index].$wrapper.width() + (this.oHotspot[index].$wrapper.offset().left *2)) *.5;
                //delta of clicked hotspot from current to center
                const iDelta = iCenter - $(ev.currentTarget).offset().left;
                //x position goto
                const iGoto = this.oHotspot[index].drag.x + iDelta - (this.oHotspot[index].iHotspotWidth *.5);
                
                //set x position && update draggable state
                var iPosX = Math.min(iGoto, this.oHotspot[index].drag.maxX);
                if(iDelta<0) {
                    iPosX = Math.max(iGoto, this.oHotspot[index].drag.minX);
                }

                TweenMax.to(this.oHotspot[index].$inner, .5, {
                    x:iPosX,
                    y:0,
                    z:0,
                    onComplete:_.bind(function() {
                        this.oHotspot[index].drag.update();
                    }, this)
                });
            }

            this.showPopup(index);
        };

        /**
         * show popup
         * 
         * @jira FDZ-682
         * @date 2023-08-04
         * @author sh@sopg.de
         * 
         * @param {int} index
         */
        this.showPopup = function(index)
        {
            TweenMax.to(this.oHotspot[index].$popup, .3, {
                autoAlpha: 1
            });
        };

        /**
         * hide popup
         * 
         * @jira FDZ-682
         * @date 2023-08-04
         * @author sh@sopg.de
         * 
         * @param {int} index
         * @param {object} ev
         */
        this.hidePopup = function(index, ev)
        {
            ev.preventDefault();
            
            if(this.oHotspot[index].$popup_content.html().length > 0) {
                oPubsub.trigger(Pubsub.DELETE_VIDEO, this.oHotspot[index].$popup_content);
                this.oHotspot[index].$popup_content.html('');
            }

            TweenMax.to(this.oHotspot[index].$popup, .3, {
                autoAlpha: 0
            });
        };

        /**
         * callback on window resize
         * 
         * @jira FDZ-682
         * @date 2023-08-04
         * @author sh@sopg.de
         */
        this.onResize = function()
        {
            _.each(this.oHotspot, function(item, index) {
                this.oHotspot[index].drag.update();

                if(this.oHotspot[index].$wrapper.width() < this.oHotspot[index].$inner.width()) {
                    this.oHotspot[index].drag.enable();
                    this.oHotspot[index].isDraggable = true;
                } else {
                    //reset tranformation, disable draggable
                    TweenMax.set(this.oHotspot[index].$inner, {x:0, y:0,z:0});
                    this.oHotspot[index].drag.update();
                    this.oHotspot[index].drag.disable();
                    this.oHotspot[index].isDraggable = false;
                }
            }, this);
        };


        this.init();
    }
});
